/* eslint-disable @typescript-eslint/naming-convention */
import React, { useState, useCallback, useMemo } from 'react';
import { Text } from '@ui/atoms/Text';
import { Button } from '@ui/atoms/Button';
import { Popup } from '../../../../../ui/molecules/Popup';
import { formatConversationDate } from '../../../../../utils/dateUtils';
import './SearchConversationPopupStyles.scss';
export function SearchConversationPopup({ anchor, conversations, isOpen, onClose, onSelectConversation }) {
    const [query, setQuery] = useState('');
    const filtered = useMemo(() => {
        if (!query.trim())
            return conversations;
        const q = query.toLowerCase();
        return conversations.filter((c) => c.title.toLowerCase().includes(q));
    }, [conversations, query]);
    const handleSelect = useCallback((id) => {
        onSelectConversation(id);
        onClose();
        setQuery('');
    }, [onSelectConversation, onClose]);
    return (React.createElement(Popup, { anchor: anchor, show: isOpen, onClose: onClose, containerClass: "ai-chat-search-popup", position: "bottom-left" },
        React.createElement(Popup.SearchInput, { value: query, onChange: setQuery }),
        React.createElement(Popup.Section, null,
            React.createElement(Popup.ActionList, null, filtered.length === 0 ? (React.createElement(Text, { variant: "body", color: "gray" }, "No conversations found")) : (filtered.map((conversation) => (React.createElement(Button, { key: conversation.sessionId, onClick: () => handleSelect(conversation.sessionId) },
                React.createElement("span", { className: "ai-chat-search-popup__title" }, conversation.title),
                React.createElement(Text, { variant: "x-small", color: "gray", className: "ai-chat-search-popup__date" }, formatConversationDate(conversation.lastActivityAt || conversation.createdAt))))))))));
}
